export default __webpack_public_path__ + "static/media/magnamalo.b937c89d.png";